import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import { incidentReportsConstants } from 'locale/incidentReports'
import { Modal } from 'antd'
import { Button, Heading, Warning, theme } from '@lmc/ui-kit'
import Divider from '@lmc/ui-kit/src/layout/Divider/Divider'
import { Text } from '@lmc/ui-kit/src/general'
import {
  ConfirmationModalContent,
  ConfirmationModalTitleContainer,
  ModalFooter,
} from '../display/commonStyledComponents'

type RemoveIncidentModalProps = {
  open: boolean
  onCancel: () => void
  onConfirm: () => void
  isRemoveLoading: boolean
}
const RemoveIncidentModal = ({
  open,
  onCancel,
  onConfirm,
  isRemoveLoading,
}: RemoveIncidentModalProps) => {
  const { t } = useTranslation(NAMESPACE.INCIDENT_REPORTS)
  return (
    <Modal
      closable={false}
      width={546}
      open={open}
      footer={[
        <ModalFooter>
          <Button onClick={onCancel}>
            {t(incidentReportsConstants.CANCEL)}
          </Button>
          <Button
            onClick={onConfirm}
            isLoading={isRemoveLoading}
            variant="danger"
          >
            {t(incidentReportsConstants.REMOVE_INCIDENT)}
          </Button>
        </ModalFooter>,
      ]}
    >
      <ConfirmationModalContent>
        <ConfirmationModalTitleContainer>
          <Warning color={theme.color.status.warning} size={24} />
          <Heading level={4}>
            {t(incidentReportsConstants.REMOVE_MODAL_TITLE)}
          </Heading>
        </ConfirmationModalTitleContainer>
        <Divider />
        <Text> {t(incidentReportsConstants.REMOVE_MODAL_DESCRIPTION)}</Text>
        <Divider />
      </ConfirmationModalContent>
    </Modal>
  )
}

export default RemoveIncidentModal
